export default class ChartStyle {
  static FONT_SIZE = 13

  static Y_AXIS_SPLIT_NUMBER = 5

  static Y_AXIS_INTERVAL = 5

  static NUMBER_FONT_FAMILY = 'Times New Roman'

  static TEXT_FONT_FAMILY = '宋体'

  static Y_AXIS_GROUP_INTERVAL = 65

  static GRID_DEFAULT_RIGHT = 40

  static COLORS = [
    '#3ba272',
    '#F44336',
    '#7E57C2',
    '#29B6F6',
    '#26A69A',
    '#8BC34A',
    '#FFEE58',
    '#FF9800',
    '#607D8B',
    '#795548',
    '#EC407A',
    '#AB47BC',
    '#26C6DA',
    '#fe7300',
    '#66BB6A',
    '#D4E157',
    '#FFCA28'
  ]
}



// WEBPACK FOOTER //
// ./src/components/DataChart/ChartStyle.js